import { render, staticRenderFns } from "./merchant-dialog.vue?vue&type=template&id=15624556&scoped=true&"
import script from "./merchant-dialog.vue?vue&type=script&lang=ts&"
export * from "./merchant-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./merchant-dialog.vue?vue&type=style&index=0&id=15624556&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15624556",
  null
  
)

export default component.exports